/* eslint-disable */
// Auto-generated by scripts/generate-shared-ui-meta.mjs
const sharedUiMetadata = [
  {
    "id": "button",
    "label": "Button",
    "sourceFiles": [
      "src/Components/ui/primitives.tsx",
      "src/Components/ui/shadcn/button.tsx"
    ],
    "usages": [
      {
        "pageFile": "src/pages/Authentication/KakaoPage.tsx",
        "routePaths": [
          "/kakao"
        ]
      },
      {
        "pageFile": "src/pages/Authentication/Login.tsx",
        "routePaths": [
          "/"
        ]
      },
      {
        "pageFile": "src/pages/Authentication/NaverPage.tsx",
        "routePaths": [
          "/naver"
        ]
      },
      {
        "pageFile": "src/pages/CampSite/Site/index.tsx",
        "routePaths": [
          "/site-form"
        ]
      },
      {
        "pageFile": "src/pages/Compliance/ComplianceArticleList.tsx",
        "routePaths": [
          "/compliance"
        ]
      },
      {
        "pageFile": "src/pages/Coupons/B2BCoupon/B2BCouponStockForm.tsx",
        "routePaths": [
          "/b2b-coupon-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/Coupons/B2BCoupon/B2BCouponStockList.tsx",
        "routePaths": [
          "/b2b-coupon-list"
        ]
      },
      {
        "pageFile": "src/pages/Coupons/BenefitRule/BenefitRuleForm.tsx",
        "routePaths": [
          "/benefit-rule-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/Coupons/BenefitRule/index.tsx",
        "routePaths": [
          "/benefit-rule-list"
        ]
      },
      {
        "pageFile": "src/pages/Coupons/Coupon/CouponForm.tsx",
        "routePaths": [
          "/coupon-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/Coupons/Coupon/index.tsx",
        "routePaths": [
          "/coupon-list"
        ]
      },
      {
        "pageFile": "src/pages/Coupons/Coupon/UserSendCoupon.tsx",
        "routePaths": [
          "/user-send-coupon"
        ]
      },
      {
        "pageFile": "src/pages/Coupons/CouponBook/CouponBookForm.tsx",
        "routePaths": [
          "/couponbook-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/Coupons/CouponBook/CouponBookRuleList.tsx",
        "routePaths": [
          "/couponbook-list"
        ]
      },
      {
        "pageFile": "src/pages/Coupons/UserCoupon/UserCouponList.tsx",
        "routePaths": [
          "/user-coupon-list"
        ]
      },
      {
        "pageFile": "src/pages/DashboardCrm/index.tsx",
        "routePaths": [
          "/dashboard-crm"
        ]
      },
      {
        "pageFile": "src/pages/Marketer/MarketerInfoPage.tsx",
        "routePaths": [
          "/marketer-info"
        ]
      },
      {
        "pageFile": "src/pages/member/AuthSessionManagementPage.tsx",
        "routePaths": [
          "/member-auth-sessions"
        ]
      },
      {
        "pageFile": "src/pages/member/InviteConfirmPage.tsx",
        "routePaths": [
          "/invite/confirm"
        ]
      },
      {
        "pageFile": "src/pages/member/InviteRegisterPage.tsx",
        "routePaths": [
          "/invite/register"
        ]
      },
      {
        "pageFile": "src/pages/member/MemberInvitationListPage.tsx",
        "routePaths": [
          "/member-invitation-list"
        ]
      },
      {
        "pageFile": "src/pages/member/MemberInvitePage.tsx",
        "routePaths": [
          "/member-invite"
        ]
      },
      {
        "pageFile": "src/pages/member/MemberListPage.tsx",
        "routePaths": [
          "/member-list"
        ]
      },
      {
        "pageFile": "src/pages/Messaging/index.ts",
        "routePaths": [
          "/messaging-history",
          "/messaging-send",
          "/messaging-senders",
          "/messaging-site-config",
          "/messaging-templates"
        ]
      },
      {
        "pageFile": "src/pages/Notice/index.ts",
        "routePaths": [
          "/announce-list",
          "/notice-form/:id",
          "/notice-list"
        ]
      },
      {
        "pageFile": "src/pages/Notification/NotificationCenter/index.tsx",
        "routePaths": [
          "/notification-center",
          "/notification-center/channels",
          "/notification-center/history",
          "/notification-center/hq",
          "/notification-center/send",
          "/notification-center/system",
          "/notification-center/templates"
        ]
      },
      {
        "pageFile": "src/pages/Notification/NotificationList/index.tsx",
        "routePaths": [
          "/notification-list"
        ]
      },
      {
        "pageFile": "src/pages/Notification/PushAppNotification.tsx",
        "routePaths": [
          "/push-app-notification"
        ]
      },
      {
        "pageFile": "src/pages/Orders/OrderErrorHandlingList.tsx",
        "routePaths": [
          "/order-error-handlings"
        ]
      },
      {
        "pageFile": "src/pages/Orders/UserOrderTotalList.tsx",
        "routePaths": [
          "/user-order-total"
        ]
      },
      {
        "pageFile": "src/pages/PreCoupons/B2BPreCoupon/B2BPreCouponStockForm.tsx",
        "routePaths": [
          "/b2b-precoupon-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/PreCoupons/B2BPreCoupon/B2BPreCouponStockList.tsx",
        "routePaths": [
          "/b2b-precoupon-list"
        ]
      },
      {
        "pageFile": "src/pages/PreCoupons/PreCouponList/index.tsx",
        "routePaths": [
          "/user-precoupon-list"
        ]
      },
      {
        "pageFile": "src/pages/PreCoupons/PreCouponProducts/index.tsx",
        "routePaths": [
          "/precoupon-list"
        ]
      },
      {
        "pageFile": "src/pages/PreCoupons/PreCouponProducts/PreCouponForm.tsx",
        "routePaths": [
          "/precoupon-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/PreCoupons/SendReservationCoupon/index.tsx",
        "routePaths": [
          "/reservation-send-coupon"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/CanceledReservationList/index.tsx",
        "routePaths": [
          "/canceled-reservation-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/DailyReservationList/index.tsx",
        "routePaths": [
          "/daily-reservation-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/FreeSeatAssignment/index.tsx",
        "routePaths": [
          "/free-seat-assignment"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/GroupReservationAgencyLinks/index.tsx",
        "routePaths": [
          "/group-reservation-agency-links"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/GroupReservationOptionProducts/index.tsx",
        "routePaths": [
          "/group-reservation-option-products"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/GroupReservationRequests/GroupReservationRequestCreate.tsx",
        "routePaths": [
          "/group-reservation-requests/new"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/GroupReservationRequests/GroupReservationRequestDetail.tsx",
        "routePaths": [
          "/group-reservation-requests/:id"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/GroupReservationRequests/index.tsx",
        "routePaths": [
          "/group-reservation-requests"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/OptionProductList/index.tsx",
        "routePaths": [
          "/option-product-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/OptionProductList/OptionAddProduct.tsx",
        "routePaths": [
          "/option-add-product/:id"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/PrivateOffers/index.tsx",
        "routePaths": [
          "/private-offers"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationCalendar/index.tsx",
        "routePaths": [
          "/reservation-calendar/"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationGiftList/index.tsx",
        "routePaths": [
          "/reservation-gift-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationList/index.tsx",
        "routePaths": [
          "/reservation-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationList/ReservationAddItem.tsx",
        "routePaths": [
          "/reservation-add-item",
          "/reservation-add-item/:id"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationOptionList/index.tsx",
        "routePaths": [
          "/reservation-option-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationOptionList/ReservationOptionAddItem.tsx",
        "routePaths": [
          "/reservation-option-add-item",
          "/reservation-option-add-item/:id"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationProducts/index.tsx",
        "routePaths": [
          "/reservation-products"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationProducts/ReservationAddProduct.tsx",
        "routePaths": [
          "/reservation-add-product/:id"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationProducts/ReservationProductDetail.tsx",
        "routePaths": [
          "/reservation-product-details/:id"
        ]
      },
      {
        "pageFile": "src/pages/Shopping/ShoppingAdmin/index.tsx",
        "routePaths": [
          "/shopping-admin"
        ]
      },
      {
        "pageFile": "src/pages/Shopping/ShoppingProducts/index.tsx",
        "routePaths": [
          "/shopping-product-list"
        ]
      },
      {
        "pageFile": "src/pages/Shopping/ShoppingProducts/ShoppingProductForm.tsx",
        "routePaths": [
          "/shopping-product-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/SiteBilling/SiteBillingInvoicesPage.tsx",
        "routePaths": [
          "/site-billing/invoices"
        ]
      },
      {
        "pageFile": "src/pages/SiteBilling/SiteBillingSitesStatusPage.tsx",
        "routePaths": [
          "/site-billing/sites-status"
        ]
      },
      {
        "pageFile": "src/pages/Statistics/CoreMetrics/index.tsx",
        "routePaths": [
          "/core-metrics"
        ]
      },
      {
        "pageFile": "src/pages/Statistics/SalesStatistics/index.tsx",
        "routePaths": [
          "/sales-statistics"
        ]
      },
      {
        "pageFile": "src/pages/Statistics/StatisticsAdjustment/index.tsx",
        "routePaths": [
          "/statistics-adjustment"
        ]
      },
      {
        "pageFile": "src/pages/Supply/SupplyAdmin/index.tsx",
        "routePaths": [
          "/supply-admin"
        ]
      },
      {
        "pageFile": "src/pages/Supply/SupplyCart/index.tsx",
        "routePaths": [
          "/supply-basket-list"
        ]
      },
      {
        "pageFile": "src/pages/Supply/SupplyList/index.tsx",
        "routePaths": [
          "/supply-list"
        ]
      },
      {
        "pageFile": "src/pages/Supply/SupplyProducts/index.tsx",
        "routePaths": [
          "/supply-product-list"
        ]
      },
      {
        "pageFile": "src/pages/Supply/SupplyProducts/SupplyProductForm.tsx",
        "routePaths": [
          "/supply-product-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/KitchenLauncher/index.tsx",
        "routePaths": [
          "/table-order/kitchen-launcher"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/MenuCategories/Form.tsx",
        "routePaths": [
          "/table-order/menu-category-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/MenuCategories/index.tsx",
        "routePaths": [
          "/table-order/menu-categories"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/Menus/Form.tsx",
        "routePaths": [
          "/table-order/menu-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/Menus/index.tsx",
        "routePaths": [
          "/table-order/menus"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/Orders/Detail.tsx",
        "routePaths": [
          "/table-order/order-detail/:id"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/Orders/index.tsx",
        "routePaths": [
          "/table-order/orders"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/POS/index.tsx",
        "routePaths": [
          "/table-order/pos"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/SeatManagement.tsx",
        "routePaths": [
          "/table-order/seat-management"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/TableGroups/Form.tsx",
        "routePaths": [
          "/table-order/table-group-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/TableGroups/index.tsx",
        "routePaths": [
          "/table-order/table-groups"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/Tables/Form.tsx",
        "routePaths": [
          "/table-order/table-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/Tables/index.tsx",
        "routePaths": [
          "/table-order/tables"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/Terminals/index.tsx",
        "routePaths": [
          "/table-order/terminals"
        ]
      },
      {
        "pageFile": "src/pages/Tickets/TicketGiftList/index.tsx",
        "routePaths": [
          "/ticket-gift-list"
        ]
      },
      {
        "pageFile": "src/pages/Tickets/TicketProducts/index.tsx",
        "routePaths": [
          "/ticket-products"
        ]
      },
      {
        "pageFile": "src/pages/Tickets/TicketProducts/TicketProductForm.tsx",
        "routePaths": [
          "/ticket-product-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/Tickets/Transactions/index.tsx",
        "routePaths": [
          "/ticket-list"
        ]
      },
      {
        "pageFile": "src/pages/Tickets/TransactionsCanceled/index.tsx",
        "routePaths": [
          "/canceled-ticket-list"
        ]
      },
      {
        "pageFile": "src/pages/Users/Profile.tsx",
        "routePaths": [
          "/profile"
        ]
      },
      {
        "pageFile": "src/pages/Users/UserDetail/index.tsx",
        "routePaths": [
          "/user/:id"
        ]
      },
      {
        "pageFile": "src/pages/Users/UserList/index.tsx",
        "routePaths": [
          "/user-list"
        ]
      },
      {
        "pageFile": "src/pages/Vouchers/B2BVoucher/B2BVoucherStockForm.tsx",
        "routePaths": [
          "/b2b-voucher-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/Vouchers/B2BVoucher/B2BVoucherStockList.tsx",
        "routePaths": [
          "/b2b-voucher-list"
        ]
      },
      {
        "pageFile": "src/pages/Vouchers/SendVoucherCoupon/index.tsx",
        "routePaths": [
          "/voucher-send-coupon"
        ]
      },
      {
        "pageFile": "src/pages/Vouchers/UserVoucherGiftList/index.tsx",
        "routePaths": [
          "/user-voucher-gift-list"
        ]
      },
      {
        "pageFile": "src/pages/Vouchers/UserVoucherList/index.tsx",
        "routePaths": [
          "/user-voucher-list"
        ]
      },
      {
        "pageFile": "src/pages/Vouchers/VoucherList/index.tsx",
        "routePaths": [
          "/voucher-list"
        ]
      },
      {
        "pageFile": "src/pages/Vouchers/VoucherList/VoucherForm.tsx",
        "routePaths": [
          "/voucher-form/:id"
        ]
      }
    ]
  },
  {
    "id": "badge",
    "label": "Badge",
    "sourceFiles": [
      "src/Components/ui/primitives.tsx",
      "src/Components/ui/shadcn/badge.tsx"
    ],
    "usages": [
      {
        "pageFile": "src/pages/Marketer/MarketerInfoPage.tsx",
        "routePaths": [
          "/marketer-info"
        ]
      },
      {
        "pageFile": "src/pages/member/AuthSessionManagementPage.tsx",
        "routePaths": [
          "/member-auth-sessions"
        ]
      },
      {
        "pageFile": "src/pages/Messaging/index.ts",
        "routePaths": [
          "/messaging-history",
          "/messaging-send",
          "/messaging-senders",
          "/messaging-site-config",
          "/messaging-templates"
        ]
      },
      {
        "pageFile": "src/pages/Notification/NotificationCenter/index.tsx",
        "routePaths": [
          "/notification-center",
          "/notification-center/channels",
          "/notification-center/history",
          "/notification-center/hq",
          "/notification-center/send",
          "/notification-center/system",
          "/notification-center/templates"
        ]
      },
      {
        "pageFile": "src/pages/Orders/OrderErrorHandlingList.tsx",
        "routePaths": [
          "/order-error-handlings"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/DailyReservationList/index.tsx",
        "routePaths": [
          "/daily-reservation-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/FreeSeatAssignment/index.tsx",
        "routePaths": [
          "/free-seat-assignment"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/GroupReservationAgencyLinks/index.tsx",
        "routePaths": [
          "/group-reservation-agency-links"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/GroupReservationOptionProducts/index.tsx",
        "routePaths": [
          "/group-reservation-option-products"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/GroupReservationRequests/GroupReservationRequestCreate.tsx",
        "routePaths": [
          "/group-reservation-requests/new"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/GroupReservationRequests/GroupReservationRequestDetail.tsx",
        "routePaths": [
          "/group-reservation-requests/:id"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/GroupReservationRequests/index.tsx",
        "routePaths": [
          "/group-reservation-requests"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationList/index.tsx",
        "routePaths": [
          "/reservation-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationProducts/ReservationAddProduct.tsx",
        "routePaths": [
          "/reservation-add-product/:id"
        ]
      },
      {
        "pageFile": "src/pages/SiteBilling/SiteBillingInvoicesPage.tsx",
        "routePaths": [
          "/site-billing/invoices"
        ]
      },
      {
        "pageFile": "src/pages/SiteBilling/SiteBillingSitesStatusPage.tsx",
        "routePaths": [
          "/site-billing/sites-status"
        ]
      },
      {
        "pageFile": "src/pages/Statistics/CoreMetrics/index.tsx",
        "routePaths": [
          "/core-metrics"
        ]
      }
    ]
  },
  {
    "id": "card",
    "label": "Card",
    "sourceFiles": [
      "src/Components/ui/primitives.tsx",
      "src/Components/ui/shadcn/card.tsx"
    ],
    "usages": [
      {
        "pageFile": "src/pages/CampSite/Site/index.tsx",
        "routePaths": [
          "/site-form"
        ]
      },
      {
        "pageFile": "src/pages/Compliance/ComplianceArticleList.tsx",
        "routePaths": [
          "/compliance"
        ]
      },
      {
        "pageFile": "src/pages/Coupons/B2BCoupon/B2BCouponStockForm.tsx",
        "routePaths": [
          "/b2b-coupon-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/Coupons/Coupon/UserSendCoupon.tsx",
        "routePaths": [
          "/user-send-coupon"
        ]
      },
      {
        "pageFile": "src/pages/Coupons/UserCoupon/UserCouponList.tsx",
        "routePaths": [
          "/user-coupon-list"
        ]
      },
      {
        "pageFile": "src/pages/Marketer/MarketerInfoPage.tsx",
        "routePaths": [
          "/marketer-info"
        ]
      },
      {
        "pageFile": "src/pages/member/AuthSessionManagementPage.tsx",
        "routePaths": [
          "/member-auth-sessions"
        ]
      },
      {
        "pageFile": "src/pages/member/InviteConfirmPage.tsx",
        "routePaths": [
          "/invite/confirm"
        ]
      },
      {
        "pageFile": "src/pages/member/InviteRegisterPage.tsx",
        "routePaths": [
          "/invite/register"
        ]
      },
      {
        "pageFile": "src/pages/member/MemberInvitationListPage.tsx",
        "routePaths": [
          "/member-invitation-list"
        ]
      },
      {
        "pageFile": "src/pages/member/MemberInvitePage.tsx",
        "routePaths": [
          "/member-invite"
        ]
      },
      {
        "pageFile": "src/pages/member/MemberListPage.tsx",
        "routePaths": [
          "/member-list"
        ]
      },
      {
        "pageFile": "src/pages/Messaging/index.ts",
        "routePaths": [
          "/messaging-history",
          "/messaging-send",
          "/messaging-senders",
          "/messaging-site-config",
          "/messaging-templates"
        ]
      },
      {
        "pageFile": "src/pages/Notice/index.ts",
        "routePaths": [
          "/announce-list",
          "/notice-form/:id",
          "/notice-list"
        ]
      },
      {
        "pageFile": "src/pages/Notification/NotificationCenter/index.tsx",
        "routePaths": [
          "/notification-center",
          "/notification-center/channels",
          "/notification-center/history",
          "/notification-center/hq",
          "/notification-center/send",
          "/notification-center/system",
          "/notification-center/templates"
        ]
      },
      {
        "pageFile": "src/pages/Notification/NotificationList/index.tsx",
        "routePaths": [
          "/notification-list"
        ]
      },
      {
        "pageFile": "src/pages/Orders/OrderErrorHandlingList.tsx",
        "routePaths": [
          "/order-error-handlings"
        ]
      },
      {
        "pageFile": "src/pages/Orders/UserOrderTotalList.tsx",
        "routePaths": [
          "/user-order-total"
        ]
      },
      {
        "pageFile": "src/pages/PreCoupons/B2BPreCoupon/B2BPreCouponStockForm.tsx",
        "routePaths": [
          "/b2b-precoupon-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/PreCoupons/PreCouponList/index.tsx",
        "routePaths": [
          "/user-precoupon-list"
        ]
      },
      {
        "pageFile": "src/pages/PreCoupons/PreCouponProducts/index.tsx",
        "routePaths": [
          "/precoupon-list"
        ]
      },
      {
        "pageFile": "src/pages/PreCoupons/SendReservationCoupon/index.tsx",
        "routePaths": [
          "/reservation-send-coupon"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/CanceledReservationList/index.tsx",
        "routePaths": [
          "/canceled-reservation-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/DailyReservationList/index.tsx",
        "routePaths": [
          "/daily-reservation-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/FreeSeatAssignment/index.tsx",
        "routePaths": [
          "/free-seat-assignment"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/GroupReservationAgencyLinks/index.tsx",
        "routePaths": [
          "/group-reservation-agency-links"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/GroupReservationOptionProducts/index.tsx",
        "routePaths": [
          "/group-reservation-option-products"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/GroupReservationRequests/GroupReservationRequestCreate.tsx",
        "routePaths": [
          "/group-reservation-requests/new"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/GroupReservationRequests/GroupReservationRequestDetail.tsx",
        "routePaths": [
          "/group-reservation-requests/:id"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/GroupReservationRequests/index.tsx",
        "routePaths": [
          "/group-reservation-requests"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/OptionProductList/index.tsx",
        "routePaths": [
          "/option-product-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/OptionProductList/OptionAddProduct.tsx",
        "routePaths": [
          "/option-add-product/:id"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/PrivateOffers/index.tsx",
        "routePaths": [
          "/private-offers"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationCalendar/index.tsx",
        "routePaths": [
          "/reservation-calendar/"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationGiftList/index.tsx",
        "routePaths": [
          "/reservation-gift-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationList/index.tsx",
        "routePaths": [
          "/reservation-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationList/ReservationAddItem.tsx",
        "routePaths": [
          "/reservation-add-item",
          "/reservation-add-item/:id"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationOptionList/index.tsx",
        "routePaths": [
          "/reservation-option-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationOptionList/ReservationOptionAddItem.tsx",
        "routePaths": [
          "/reservation-option-add-item",
          "/reservation-option-add-item/:id"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationProducts/index.tsx",
        "routePaths": [
          "/reservation-products"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationProducts/ReservationAddProduct.tsx",
        "routePaths": [
          "/reservation-add-product/:id"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationProducts/ReservationProductDetail.tsx",
        "routePaths": [
          "/reservation-product-details/:id"
        ]
      },
      {
        "pageFile": "src/pages/Shopping/ShoppingAdmin/index.tsx",
        "routePaths": [
          "/shopping-admin"
        ]
      },
      {
        "pageFile": "src/pages/Shopping/ShoppingProducts/index.tsx",
        "routePaths": [
          "/shopping-product-list"
        ]
      },
      {
        "pageFile": "src/pages/Shopping/ShoppingProducts/ShoppingProductForm.tsx",
        "routePaths": [
          "/shopping-product-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/SiteBilling/SiteBillingInvoicesPage.tsx",
        "routePaths": [
          "/site-billing/invoices"
        ]
      },
      {
        "pageFile": "src/pages/SiteBilling/SiteBillingSitesStatusPage.tsx",
        "routePaths": [
          "/site-billing/sites-status"
        ]
      },
      {
        "pageFile": "src/pages/Statistics/CoreMetrics/index.tsx",
        "routePaths": [
          "/core-metrics"
        ]
      },
      {
        "pageFile": "src/pages/Statistics/SalesStatistics/index.tsx",
        "routePaths": [
          "/sales-statistics"
        ]
      },
      {
        "pageFile": "src/pages/Statistics/StatisticsAdjustment/index.tsx",
        "routePaths": [
          "/statistics-adjustment"
        ]
      },
      {
        "pageFile": "src/pages/Supply/SupplyAdmin/index.tsx",
        "routePaths": [
          "/supply-admin"
        ]
      },
      {
        "pageFile": "src/pages/Supply/SupplyCart/index.tsx",
        "routePaths": [
          "/supply-basket-list"
        ]
      },
      {
        "pageFile": "src/pages/Supply/SupplyList/index.tsx",
        "routePaths": [
          "/supply-list"
        ]
      },
      {
        "pageFile": "src/pages/Supply/SupplyProducts/index.tsx",
        "routePaths": [
          "/supply-product-list"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/KitchenLauncher/index.tsx",
        "routePaths": [
          "/table-order/kitchen-launcher"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/MenuCategories/Form.tsx",
        "routePaths": [
          "/table-order/menu-category-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/MenuCategories/index.tsx",
        "routePaths": [
          "/table-order/menu-categories"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/Menus/Form.tsx",
        "routePaths": [
          "/table-order/menu-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/Menus/index.tsx",
        "routePaths": [
          "/table-order/menus"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/Orders/Detail.tsx",
        "routePaths": [
          "/table-order/order-detail/:id"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/Orders/index.tsx",
        "routePaths": [
          "/table-order/orders"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/POS/index.tsx",
        "routePaths": [
          "/table-order/pos"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/SeatManagement.tsx",
        "routePaths": [
          "/table-order/seat-management"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/TableGroups/Form.tsx",
        "routePaths": [
          "/table-order/table-group-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/TableGroups/index.tsx",
        "routePaths": [
          "/table-order/table-groups"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/Tables/Form.tsx",
        "routePaths": [
          "/table-order/table-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/Tables/index.tsx",
        "routePaths": [
          "/table-order/tables"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/Terminals/index.tsx",
        "routePaths": [
          "/table-order/terminals"
        ]
      },
      {
        "pageFile": "src/pages/Tickets/TicketGiftList/index.tsx",
        "routePaths": [
          "/ticket-gift-list"
        ]
      },
      {
        "pageFile": "src/pages/Tickets/TicketProducts/TicketProductForm.tsx",
        "routePaths": [
          "/ticket-product-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/Tickets/Transactions/index.tsx",
        "routePaths": [
          "/ticket-list"
        ]
      },
      {
        "pageFile": "src/pages/Tickets/TransactionsCanceled/index.tsx",
        "routePaths": [
          "/canceled-ticket-list"
        ]
      },
      {
        "pageFile": "src/pages/Users/Profile.tsx",
        "routePaths": [
          "/profile"
        ]
      },
      {
        "pageFile": "src/pages/Users/UserDetail/index.tsx",
        "routePaths": [
          "/user/:id"
        ]
      },
      {
        "pageFile": "src/pages/Users/UserList/index.tsx",
        "routePaths": [
          "/user-list"
        ]
      },
      {
        "pageFile": "src/pages/Vouchers/B2BVoucher/B2BVoucherStockForm.tsx",
        "routePaths": [
          "/b2b-voucher-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/Vouchers/SendVoucherCoupon/index.tsx",
        "routePaths": [
          "/voucher-send-coupon"
        ]
      },
      {
        "pageFile": "src/pages/Vouchers/UserVoucherGiftList/index.tsx",
        "routePaths": [
          "/user-voucher-gift-list"
        ]
      },
      {
        "pageFile": "src/pages/Vouchers/UserVoucherList/index.tsx",
        "routePaths": [
          "/user-voucher-list"
        ]
      },
      {
        "pageFile": "src/pages/Vouchers/VoucherList/VoucherForm.tsx",
        "routePaths": [
          "/voucher-form/:id"
        ]
      }
    ]
  },
  {
    "id": "modal",
    "label": "Modal",
    "sourceFiles": [
      "src/Components/ui/Modal.tsx"
    ],
    "usages": [
      {
        "pageFile": "src/pages/CampSite/Site/index.tsx",
        "routePaths": [
          "/site-form"
        ]
      },
      {
        "pageFile": "src/pages/Compliance/ComplianceArticleList.tsx",
        "routePaths": [
          "/compliance"
        ]
      },
      {
        "pageFile": "src/pages/Coupons/B2BCoupon/B2BCouponStockList.tsx",
        "routePaths": [
          "/b2b-coupon-list"
        ]
      },
      {
        "pageFile": "src/pages/Coupons/BenefitRule/index.tsx",
        "routePaths": [
          "/benefit-rule-list"
        ]
      },
      {
        "pageFile": "src/pages/Coupons/Coupon/CouponForm.tsx",
        "routePaths": [
          "/coupon-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/Coupons/Coupon/index.tsx",
        "routePaths": [
          "/coupon-list"
        ]
      },
      {
        "pageFile": "src/pages/Coupons/CouponBook/CouponBookRuleList.tsx",
        "routePaths": [
          "/couponbook-list"
        ]
      },
      {
        "pageFile": "src/pages/Coupons/UserCoupon/UserCouponList.tsx",
        "routePaths": [
          "/user-coupon-list"
        ]
      },
      {
        "pageFile": "src/pages/DashboardCrm/index.tsx",
        "routePaths": [
          "/dashboard-crm"
        ]
      },
      {
        "pageFile": "src/pages/member/MemberListPage.tsx",
        "routePaths": [
          "/member-list"
        ]
      },
      {
        "pageFile": "src/pages/Messaging/index.ts",
        "routePaths": [
          "/messaging-history",
          "/messaging-send",
          "/messaging-senders",
          "/messaging-site-config",
          "/messaging-templates"
        ]
      },
      {
        "pageFile": "src/pages/Notice/index.ts",
        "routePaths": [
          "/announce-list",
          "/notice-form/:id",
          "/notice-list"
        ]
      },
      {
        "pageFile": "src/pages/Notification/NotificationCenter/index.tsx",
        "routePaths": [
          "/notification-center",
          "/notification-center/channels",
          "/notification-center/history",
          "/notification-center/hq",
          "/notification-center/send",
          "/notification-center/system",
          "/notification-center/templates"
        ]
      },
      {
        "pageFile": "src/pages/Orders/OrderErrorHandlingList.tsx",
        "routePaths": [
          "/order-error-handlings"
        ]
      },
      {
        "pageFile": "src/pages/Orders/UserOrderTotalList.tsx",
        "routePaths": [
          "/user-order-total"
        ]
      },
      {
        "pageFile": "src/pages/PreCoupons/B2BPreCoupon/B2BPreCouponStockList.tsx",
        "routePaths": [
          "/b2b-precoupon-list"
        ]
      },
      {
        "pageFile": "src/pages/PreCoupons/PreCouponList/index.tsx",
        "routePaths": [
          "/user-precoupon-list"
        ]
      },
      {
        "pageFile": "src/pages/PreCoupons/PreCouponProducts/index.tsx",
        "routePaths": [
          "/precoupon-list"
        ]
      },
      {
        "pageFile": "src/pages/PreCoupons/PreCouponProducts/PreCouponForm.tsx",
        "routePaths": [
          "/precoupon-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/CanceledReservationList/index.tsx",
        "routePaths": [
          "/canceled-reservation-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/DailyReservationList/index.tsx",
        "routePaths": [
          "/daily-reservation-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/GroupReservationRequests/GroupReservationRequestDetail.tsx",
        "routePaths": [
          "/group-reservation-requests/:id"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/GroupReservationRequests/index.tsx",
        "routePaths": [
          "/group-reservation-requests"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/OptionProductList/index.tsx",
        "routePaths": [
          "/option-product-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationCalendar/index.tsx",
        "routePaths": [
          "/reservation-calendar/"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationGiftList/index.tsx",
        "routePaths": [
          "/reservation-gift-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationList/index.tsx",
        "routePaths": [
          "/reservation-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationOptionList/index.tsx",
        "routePaths": [
          "/reservation-option-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationProducts/index.tsx",
        "routePaths": [
          "/reservation-products"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationProducts/ReservationAddProduct.tsx",
        "routePaths": [
          "/reservation-add-product/:id"
        ]
      },
      {
        "pageFile": "src/pages/Shopping/ShoppingAdmin/index.tsx",
        "routePaths": [
          "/shopping-admin"
        ]
      },
      {
        "pageFile": "src/pages/Shopping/ShoppingProducts/index.tsx",
        "routePaths": [
          "/shopping-product-list"
        ]
      },
      {
        "pageFile": "src/pages/Statistics/StatisticsAdjustment/index.tsx",
        "routePaths": [
          "/statistics-adjustment"
        ]
      },
      {
        "pageFile": "src/pages/Supply/SupplyAdmin/index.tsx",
        "routePaths": [
          "/supply-admin"
        ]
      },
      {
        "pageFile": "src/pages/Supply/SupplyCart/index.tsx",
        "routePaths": [
          "/supply-basket-list"
        ]
      },
      {
        "pageFile": "src/pages/Supply/SupplyList/index.tsx",
        "routePaths": [
          "/supply-list"
        ]
      },
      {
        "pageFile": "src/pages/Supply/SupplyProducts/index.tsx",
        "routePaths": [
          "/supply-product-list"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/POS/index.tsx",
        "routePaths": [
          "/table-order/pos"
        ]
      },
      {
        "pageFile": "src/pages/Tickets/TicketGiftList/index.tsx",
        "routePaths": [
          "/ticket-gift-list"
        ]
      },
      {
        "pageFile": "src/pages/Tickets/TicketProducts/index.tsx",
        "routePaths": [
          "/ticket-products"
        ]
      },
      {
        "pageFile": "src/pages/Tickets/Transactions/index.tsx",
        "routePaths": [
          "/ticket-list"
        ]
      },
      {
        "pageFile": "src/pages/Tickets/TransactionsCanceled/index.tsx",
        "routePaths": [
          "/canceled-ticket-list"
        ]
      },
      {
        "pageFile": "src/pages/Users/UserDetail/index.tsx",
        "routePaths": [
          "/user/:id"
        ]
      },
      {
        "pageFile": "src/pages/Users/UserList/index.tsx",
        "routePaths": [
          "/user-list"
        ]
      },
      {
        "pageFile": "src/pages/Vouchers/B2BVoucher/B2BVoucherStockList.tsx",
        "routePaths": [
          "/b2b-voucher-list"
        ]
      },
      {
        "pageFile": "src/pages/Vouchers/UserVoucherGiftList/index.tsx",
        "routePaths": [
          "/user-voucher-gift-list"
        ]
      },
      {
        "pageFile": "src/pages/Vouchers/UserVoucherList/index.tsx",
        "routePaths": [
          "/user-voucher-list"
        ]
      },
      {
        "pageFile": "src/pages/Vouchers/VoucherList/index.tsx",
        "routePaths": [
          "/voucher-list"
        ]
      },
      {
        "pageFile": "src/pages/Vouchers/VoucherList/VoucherForm.tsx",
        "routePaths": [
          "/voucher-form/:id"
        ]
      }
    ]
  },
  {
    "id": "dialog",
    "label": "Dialog",
    "sourceFiles": [
      "src/Components/Common/DialogProvider.tsx",
      "src/Components/Common/CommonDialog.tsx",
      "src/utils/dialogService.ts"
    ],
    "usages": [
      {
        "pageFile": "src/pages/Authentication/KakaoPage.tsx",
        "routePaths": [
          "/kakao"
        ]
      },
      {
        "pageFile": "src/pages/Authentication/Login.tsx",
        "routePaths": [
          "/"
        ]
      },
      {
        "pageFile": "src/pages/Authentication/NaverPage.tsx",
        "routePaths": [
          "/naver"
        ]
      },
      {
        "pageFile": "src/pages/CampSite/Site/index.tsx",
        "routePaths": [
          "/site-form"
        ]
      },
      {
        "pageFile": "src/pages/Compliance/ComplianceArticleList.tsx",
        "routePaths": [
          "/compliance"
        ]
      },
      {
        "pageFile": "src/pages/Coupons/B2BCoupon/B2BCouponStockForm.tsx",
        "routePaths": [
          "/b2b-coupon-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/Coupons/B2BCoupon/B2BCouponStockList.tsx",
        "routePaths": [
          "/b2b-coupon-list"
        ]
      },
      {
        "pageFile": "src/pages/Coupons/BenefitRule/BenefitRuleForm.tsx",
        "routePaths": [
          "/benefit-rule-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/Coupons/BenefitRule/index.tsx",
        "routePaths": [
          "/benefit-rule-list"
        ]
      },
      {
        "pageFile": "src/pages/Coupons/Coupon/CouponForm.tsx",
        "routePaths": [
          "/coupon-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/Coupons/Coupon/index.tsx",
        "routePaths": [
          "/coupon-list"
        ]
      },
      {
        "pageFile": "src/pages/Coupons/Coupon/UserSendCoupon.tsx",
        "routePaths": [
          "/user-send-coupon"
        ]
      },
      {
        "pageFile": "src/pages/Coupons/CouponBook/CouponBookForm.tsx",
        "routePaths": [
          "/couponbook-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/Coupons/CouponBook/CouponBookRuleList.tsx",
        "routePaths": [
          "/couponbook-list"
        ]
      },
      {
        "pageFile": "src/pages/Coupons/UserCoupon/UserCouponList.tsx",
        "routePaths": [
          "/user-coupon-list"
        ]
      },
      {
        "pageFile": "src/pages/DashboardCrm/index.tsx",
        "routePaths": [
          "/dashboard-crm"
        ]
      },
      {
        "pageFile": "src/pages/Marketer/MarketerInfoPage.tsx",
        "routePaths": [
          "/marketer-info"
        ]
      },
      {
        "pageFile": "src/pages/member/AuthSessionManagementPage.tsx",
        "routePaths": [
          "/member-auth-sessions"
        ]
      },
      {
        "pageFile": "src/pages/member/InviteConfirmPage.tsx",
        "routePaths": [
          "/invite/confirm"
        ]
      },
      {
        "pageFile": "src/pages/member/InviteRegisterPage.tsx",
        "routePaths": [
          "/invite/register"
        ]
      },
      {
        "pageFile": "src/pages/member/MemberInvitationListPage.tsx",
        "routePaths": [
          "/member-invitation-list"
        ]
      },
      {
        "pageFile": "src/pages/member/MemberInvitePage.tsx",
        "routePaths": [
          "/member-invite"
        ]
      },
      {
        "pageFile": "src/pages/member/MemberListPage.tsx",
        "routePaths": [
          "/member-list"
        ]
      },
      {
        "pageFile": "src/pages/Messaging/index.ts",
        "routePaths": [
          "/messaging-history",
          "/messaging-send",
          "/messaging-senders",
          "/messaging-site-config",
          "/messaging-templates"
        ]
      },
      {
        "pageFile": "src/pages/Notice/index.ts",
        "routePaths": [
          "/announce-list",
          "/notice-form/:id",
          "/notice-list"
        ]
      },
      {
        "pageFile": "src/pages/Notification/NotificationCenter/index.tsx",
        "routePaths": [
          "/notification-center",
          "/notification-center/channels",
          "/notification-center/history",
          "/notification-center/hq",
          "/notification-center/send",
          "/notification-center/system",
          "/notification-center/templates"
        ]
      },
      {
        "pageFile": "src/pages/Notification/NotificationList/index.tsx",
        "routePaths": [
          "/notification-list"
        ]
      },
      {
        "pageFile": "src/pages/Notification/PushAppNotification.tsx",
        "routePaths": [
          "/push-app-notification"
        ]
      },
      {
        "pageFile": "src/pages/Orders/OrderErrorHandlingList.tsx",
        "routePaths": [
          "/order-error-handlings"
        ]
      },
      {
        "pageFile": "src/pages/Orders/UserOrderTotalList.tsx",
        "routePaths": [
          "/user-order-total"
        ]
      },
      {
        "pageFile": "src/pages/PreCoupons/B2BPreCoupon/B2BPreCouponStockForm.tsx",
        "routePaths": [
          "/b2b-precoupon-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/PreCoupons/B2BPreCoupon/B2BPreCouponStockList.tsx",
        "routePaths": [
          "/b2b-precoupon-list"
        ]
      },
      {
        "pageFile": "src/pages/PreCoupons/PreCouponList/index.tsx",
        "routePaths": [
          "/user-precoupon-list"
        ]
      },
      {
        "pageFile": "src/pages/PreCoupons/PreCouponProducts/index.tsx",
        "routePaths": [
          "/precoupon-list"
        ]
      },
      {
        "pageFile": "src/pages/PreCoupons/PreCouponProducts/PreCouponForm.tsx",
        "routePaths": [
          "/precoupon-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/PreCoupons/SendReservationCoupon/index.tsx",
        "routePaths": [
          "/reservation-send-coupon"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/CanceledReservationList/index.tsx",
        "routePaths": [
          "/canceled-reservation-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/DailyReservationList/index.tsx",
        "routePaths": [
          "/daily-reservation-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/FreeSeatAssignment/index.tsx",
        "routePaths": [
          "/free-seat-assignment"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/GroupReservationAgencyLinks/index.tsx",
        "routePaths": [
          "/group-reservation-agency-links"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/GroupReservationOptionProducts/index.tsx",
        "routePaths": [
          "/group-reservation-option-products"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/GroupReservationRequests/GroupReservationRequestCreate.tsx",
        "routePaths": [
          "/group-reservation-requests/new"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/GroupReservationRequests/GroupReservationRequestDetail.tsx",
        "routePaths": [
          "/group-reservation-requests/:id"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/GroupReservationRequests/index.tsx",
        "routePaths": [
          "/group-reservation-requests"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/OptionProductList/index.tsx",
        "routePaths": [
          "/option-product-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/OptionProductList/OptionAddProduct.tsx",
        "routePaths": [
          "/option-add-product/:id"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/PrivateOffers/index.tsx",
        "routePaths": [
          "/private-offers"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationCalendar/index.tsx",
        "routePaths": [
          "/reservation-calendar/"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationCancel/index.tsx",
        "routePaths": [
          "/reservation-cancel/:id"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationGiftList/index.tsx",
        "routePaths": [
          "/reservation-gift-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationList/index.tsx",
        "routePaths": [
          "/reservation-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationList/ReservationAddItem.tsx",
        "routePaths": [
          "/reservation-add-item",
          "/reservation-add-item/:id"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationOptionList/index.tsx",
        "routePaths": [
          "/reservation-option-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationOptionList/ReservationOptionAddItem.tsx",
        "routePaths": [
          "/reservation-option-add-item",
          "/reservation-option-add-item/:id"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationProducts/index.tsx",
        "routePaths": [
          "/reservation-products"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationProducts/ReservationAddProduct.tsx",
        "routePaths": [
          "/reservation-add-product/:id"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationProducts/seatmap.tsx",
        "routePaths": [
          "/seat-map"
        ]
      },
      {
        "pageFile": "src/pages/Shopping/ShoppingAdmin/index.tsx",
        "routePaths": [
          "/shopping-admin"
        ]
      },
      {
        "pageFile": "src/pages/Shopping/ShoppingProducts/index.tsx",
        "routePaths": [
          "/shopping-product-list"
        ]
      },
      {
        "pageFile": "src/pages/Shopping/ShoppingProducts/ShoppingProductForm.tsx",
        "routePaths": [
          "/shopping-product-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/SiteBilling/SiteBillingInvoicesPage.tsx",
        "routePaths": [
          "/site-billing/invoices"
        ]
      },
      {
        "pageFile": "src/pages/SiteBilling/SiteBillingSitesStatusPage.tsx",
        "routePaths": [
          "/site-billing/sites-status"
        ]
      },
      {
        "pageFile": "src/pages/Statistics/CoreMetrics/index.tsx",
        "routePaths": [
          "/core-metrics"
        ]
      },
      {
        "pageFile": "src/pages/Statistics/SalesStatistics/index.tsx",
        "routePaths": [
          "/sales-statistics"
        ]
      },
      {
        "pageFile": "src/pages/Statistics/StatisticsAdjustment/index.tsx",
        "routePaths": [
          "/statistics-adjustment"
        ]
      },
      {
        "pageFile": "src/pages/Supply/SupplyAdmin/index.tsx",
        "routePaths": [
          "/supply-admin"
        ]
      },
      {
        "pageFile": "src/pages/Supply/SupplyCart/index.tsx",
        "routePaths": [
          "/supply-basket-list"
        ]
      },
      {
        "pageFile": "src/pages/Supply/SupplyList/index.tsx",
        "routePaths": [
          "/supply-list"
        ]
      },
      {
        "pageFile": "src/pages/Supply/SupplyProducts/index.tsx",
        "routePaths": [
          "/supply-product-list"
        ]
      },
      {
        "pageFile": "src/pages/Supply/SupplyProducts/SupplyProductForm.tsx",
        "routePaths": [
          "/supply-product-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/KitchenLauncher/index.tsx",
        "routePaths": [
          "/table-order/kitchen-launcher"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/MenuCategories/Form.tsx",
        "routePaths": [
          "/table-order/menu-category-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/MenuCategories/index.tsx",
        "routePaths": [
          "/table-order/menu-categories"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/Menus/Form.tsx",
        "routePaths": [
          "/table-order/menu-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/Menus/index.tsx",
        "routePaths": [
          "/table-order/menus"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/Orders/Detail.tsx",
        "routePaths": [
          "/table-order/order-detail/:id"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/Orders/index.tsx",
        "routePaths": [
          "/table-order/orders"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/POS/index.tsx",
        "routePaths": [
          "/table-order/pos"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/SeatManagement.tsx",
        "routePaths": [
          "/table-order/seat-management"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/TableGroups/Form.tsx",
        "routePaths": [
          "/table-order/table-group-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/TableGroups/index.tsx",
        "routePaths": [
          "/table-order/table-groups"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/Tables/Form.tsx",
        "routePaths": [
          "/table-order/table-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/Tables/index.tsx",
        "routePaths": [
          "/table-order/tables"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/Terminals/index.tsx",
        "routePaths": [
          "/table-order/terminals"
        ]
      },
      {
        "pageFile": "src/pages/Tickets/TicketGiftList/index.tsx",
        "routePaths": [
          "/ticket-gift-list"
        ]
      },
      {
        "pageFile": "src/pages/Tickets/TicketProducts/index.tsx",
        "routePaths": [
          "/ticket-products"
        ]
      },
      {
        "pageFile": "src/pages/Tickets/TicketProducts/TicketProductForm.tsx",
        "routePaths": [
          "/ticket-product-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/Tickets/Transactions/index.tsx",
        "routePaths": [
          "/ticket-list"
        ]
      },
      {
        "pageFile": "src/pages/Tickets/TransactionsCanceled/index.tsx",
        "routePaths": [
          "/canceled-ticket-list"
        ]
      },
      {
        "pageFile": "src/pages/Users/Profile.tsx",
        "routePaths": [
          "/profile"
        ]
      },
      {
        "pageFile": "src/pages/Users/UserDetail/index.tsx",
        "routePaths": [
          "/user/:id"
        ]
      },
      {
        "pageFile": "src/pages/Users/UserList/index.tsx",
        "routePaths": [
          "/user-list"
        ]
      },
      {
        "pageFile": "src/pages/Vouchers/B2BVoucher/B2BVoucherStockForm.tsx",
        "routePaths": [
          "/b2b-voucher-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/Vouchers/B2BVoucher/B2BVoucherStockList.tsx",
        "routePaths": [
          "/b2b-voucher-list"
        ]
      },
      {
        "pageFile": "src/pages/Vouchers/SendVoucherCoupon/index.tsx",
        "routePaths": [
          "/voucher-send-coupon"
        ]
      },
      {
        "pageFile": "src/pages/Vouchers/UserVoucherGiftList/index.tsx",
        "routePaths": [
          "/user-voucher-gift-list"
        ]
      },
      {
        "pageFile": "src/pages/Vouchers/UserVoucherList/index.tsx",
        "routePaths": [
          "/user-voucher-list"
        ]
      },
      {
        "pageFile": "src/pages/Vouchers/VoucherList/index.tsx",
        "routePaths": [
          "/voucher-list"
        ]
      },
      {
        "pageFile": "src/pages/Vouchers/VoucherList/VoucherForm.tsx",
        "routePaths": [
          "/voucher-form/:id"
        ]
      }
    ]
  },
  {
    "id": "dropdown",
    "label": "Dropdown",
    "sourceFiles": [
      "src/Components/ui/Dropdown.tsx"
    ],
    "usages": [
      {
        "pageFile": "src/pages/DashboardCrm/index.tsx",
        "routePaths": [
          "/dashboard-crm"
        ]
      },
      {
        "pageFile": "src/pages/Messaging/index.ts",
        "routePaths": [
          "/messaging-history",
          "/messaging-send",
          "/messaging-senders",
          "/messaging-site-config",
          "/messaging-templates"
        ]
      },
      {
        "pageFile": "src/pages/Statistics/SalesStatistics/index.tsx",
        "routePaths": [
          "/sales-statistics"
        ]
      },
      {
        "pageFile": "src/pages/Supply/SupplyList/index.tsx",
        "routePaths": [
          "/supply-list"
        ]
      },
      {
        "pageFile": "src/pages/Tickets/Transactions/index.tsx",
        "routePaths": [
          "/ticket-list"
        ]
      },
      {
        "pageFile": "src/pages/Tickets/TransactionsCanceled/index.tsx",
        "routePaths": [
          "/canceled-ticket-list"
        ]
      },
      {
        "pageFile": "src/pages/Users/UserDetail/index.tsx",
        "routePaths": [
          "/user/:id"
        ]
      }
    ]
  },
  {
    "id": "form",
    "label": "Form",
    "sourceFiles": [
      "src/Components/ui/primitives.tsx"
    ],
    "usages": [
      {
        "pageFile": "src/pages/CampSite/Site/index.tsx",
        "routePaths": [
          "/site-form"
        ]
      },
      {
        "pageFile": "src/pages/Messaging/index.ts",
        "routePaths": [
          "/messaging-history",
          "/messaging-send",
          "/messaging-senders",
          "/messaging-site-config",
          "/messaging-templates"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/CanceledReservationList/index.tsx",
        "routePaths": [
          "/canceled-reservation-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/DailyReservationList/index.tsx",
        "routePaths": [
          "/daily-reservation-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationCalendar/index.tsx",
        "routePaths": [
          "/reservation-calendar/"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationGiftList/index.tsx",
        "routePaths": [
          "/reservation-gift-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationList/index.tsx",
        "routePaths": [
          "/reservation-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationOptionList/index.tsx",
        "routePaths": [
          "/reservation-option-list"
        ]
      },
      {
        "pageFile": "src/pages/Supply/SupplyAdmin/index.tsx",
        "routePaths": [
          "/supply-admin"
        ]
      },
      {
        "pageFile": "src/pages/Supply/SupplyList/index.tsx",
        "routePaths": [
          "/supply-list"
        ]
      },
      {
        "pageFile": "src/pages/Tickets/TicketGiftList/index.tsx",
        "routePaths": [
          "/ticket-gift-list"
        ]
      },
      {
        "pageFile": "src/pages/Tickets/Transactions/index.tsx",
        "routePaths": [
          "/ticket-list"
        ]
      },
      {
        "pageFile": "src/pages/Tickets/TransactionsCanceled/index.tsx",
        "routePaths": [
          "/canceled-ticket-list"
        ]
      },
      {
        "pageFile": "src/pages/Users/Profile.tsx",
        "routePaths": [
          "/profile"
        ]
      },
      {
        "pageFile": "src/pages/Users/UserDetail/index.tsx",
        "routePaths": [
          "/user/:id"
        ]
      },
      {
        "pageFile": "src/pages/Vouchers/UserVoucherGiftList/index.tsx",
        "routePaths": [
          "/user-voucher-gift-list"
        ]
      }
    ]
  },
  {
    "id": "input",
    "label": "Input",
    "sourceFiles": [
      "src/Components/ui/primitives.tsx"
    ],
    "usages": [
      {
        "pageFile": "src/pages/CampSite/Site/index.tsx",
        "routePaths": [
          "/site-form"
        ]
      },
      {
        "pageFile": "src/pages/Compliance/ComplianceArticleList.tsx",
        "routePaths": [
          "/compliance"
        ]
      },
      {
        "pageFile": "src/pages/Coupons/B2BCoupon/B2BCouponStockForm.tsx",
        "routePaths": [
          "/b2b-coupon-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/Coupons/Coupon/UserSendCoupon.tsx",
        "routePaths": [
          "/user-send-coupon"
        ]
      },
      {
        "pageFile": "src/pages/Coupons/UserCoupon/UserCouponList.tsx",
        "routePaths": [
          "/user-coupon-list"
        ]
      },
      {
        "pageFile": "src/pages/Marketer/MarketerInfoPage.tsx",
        "routePaths": [
          "/marketer-info"
        ]
      },
      {
        "pageFile": "src/pages/member/MemberInvitePage.tsx",
        "routePaths": [
          "/member-invite"
        ]
      },
      {
        "pageFile": "src/pages/member/MemberListPage.tsx",
        "routePaths": [
          "/member-list"
        ]
      },
      {
        "pageFile": "src/pages/Messaging/index.ts",
        "routePaths": [
          "/messaging-history",
          "/messaging-send",
          "/messaging-senders",
          "/messaging-site-config",
          "/messaging-templates"
        ]
      },
      {
        "pageFile": "src/pages/Notice/index.ts",
        "routePaths": [
          "/announce-list",
          "/notice-form/:id",
          "/notice-list"
        ]
      },
      {
        "pageFile": "src/pages/Notification/NotificationCenter/index.tsx",
        "routePaths": [
          "/notification-center",
          "/notification-center/channels",
          "/notification-center/history",
          "/notification-center/hq",
          "/notification-center/send",
          "/notification-center/system",
          "/notification-center/templates"
        ]
      },
      {
        "pageFile": "src/pages/Notification/NotificationList/index.tsx",
        "routePaths": [
          "/notification-list"
        ]
      },
      {
        "pageFile": "src/pages/Orders/UserOrderTotalList.tsx",
        "routePaths": [
          "/user-order-total"
        ]
      },
      {
        "pageFile": "src/pages/PreCoupons/B2BPreCoupon/B2BPreCouponStockForm.tsx",
        "routePaths": [
          "/b2b-precoupon-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/PreCoupons/PreCouponList/index.tsx",
        "routePaths": [
          "/user-precoupon-list"
        ]
      },
      {
        "pageFile": "src/pages/PreCoupons/PreCouponProducts/PreCouponForm.tsx",
        "routePaths": [
          "/precoupon-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/PreCoupons/SendReservationCoupon/index.tsx",
        "routePaths": [
          "/reservation-send-coupon"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/CanceledReservationList/index.tsx",
        "routePaths": [
          "/canceled-reservation-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/DailyReservationList/index.tsx",
        "routePaths": [
          "/daily-reservation-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/FreeSeatAssignment/index.tsx",
        "routePaths": [
          "/free-seat-assignment"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/GroupReservationAgencyLinks/index.tsx",
        "routePaths": [
          "/group-reservation-agency-links"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/GroupReservationOptionProducts/index.tsx",
        "routePaths": [
          "/group-reservation-option-products"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/GroupReservationRequests/GroupReservationRequestCreate.tsx",
        "routePaths": [
          "/group-reservation-requests/new"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/GroupReservationRequests/GroupReservationRequestDetail.tsx",
        "routePaths": [
          "/group-reservation-requests/:id"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/GroupReservationRequests/index.tsx",
        "routePaths": [
          "/group-reservation-requests"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/OptionProductList/index.tsx",
        "routePaths": [
          "/option-product-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/OptionProductList/OptionAddProduct.tsx",
        "routePaths": [
          "/option-add-product/:id"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationCalendar/index.tsx",
        "routePaths": [
          "/reservation-calendar/"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationGiftList/index.tsx",
        "routePaths": [
          "/reservation-gift-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationList/index.tsx",
        "routePaths": [
          "/reservation-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationList/ReservationAddItem.tsx",
        "routePaths": [
          "/reservation-add-item",
          "/reservation-add-item/:id"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationOptionList/index.tsx",
        "routePaths": [
          "/reservation-option-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationOptionList/ReservationOptionAddItem.tsx",
        "routePaths": [
          "/reservation-option-add-item",
          "/reservation-option-add-item/:id"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationProducts/ReservationAddProduct.tsx",
        "routePaths": [
          "/reservation-add-product/:id"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationProducts/ReservationProductDetail.tsx",
        "routePaths": [
          "/reservation-product-details/:id"
        ]
      },
      {
        "pageFile": "src/pages/Shopping/ShoppingProducts/index.tsx",
        "routePaths": [
          "/shopping-product-list"
        ]
      },
      {
        "pageFile": "src/pages/Shopping/ShoppingProducts/ShoppingProductForm.tsx",
        "routePaths": [
          "/shopping-product-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/SiteBilling/SiteBillingInvoicesPage.tsx",
        "routePaths": [
          "/site-billing/invoices"
        ]
      },
      {
        "pageFile": "src/pages/SiteBilling/SiteBillingSitesStatusPage.tsx",
        "routePaths": [
          "/site-billing/sites-status"
        ]
      },
      {
        "pageFile": "src/pages/Statistics/StatisticsAdjustment/index.tsx",
        "routePaths": [
          "/statistics-adjustment"
        ]
      },
      {
        "pageFile": "src/pages/Supply/SupplyAdmin/index.tsx",
        "routePaths": [
          "/supply-admin"
        ]
      },
      {
        "pageFile": "src/pages/Supply/SupplyCart/index.tsx",
        "routePaths": [
          "/supply-basket-list"
        ]
      },
      {
        "pageFile": "src/pages/Supply/SupplyList/index.tsx",
        "routePaths": [
          "/supply-list"
        ]
      },
      {
        "pageFile": "src/pages/Supply/SupplyProducts/index.tsx",
        "routePaths": [
          "/supply-product-list"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/MenuCategories/Form.tsx",
        "routePaths": [
          "/table-order/menu-category-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/Menus/Form.tsx",
        "routePaths": [
          "/table-order/menu-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/Menus/index.tsx",
        "routePaths": [
          "/table-order/menus"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/POS/index.tsx",
        "routePaths": [
          "/table-order/pos"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/SeatManagement.tsx",
        "routePaths": [
          "/table-order/seat-management"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/TableGroups/Form.tsx",
        "routePaths": [
          "/table-order/table-group-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/Tables/Form.tsx",
        "routePaths": [
          "/table-order/table-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/Terminals/index.tsx",
        "routePaths": [
          "/table-order/terminals"
        ]
      },
      {
        "pageFile": "src/pages/Tickets/TicketGiftList/index.tsx",
        "routePaths": [
          "/ticket-gift-list"
        ]
      },
      {
        "pageFile": "src/pages/Tickets/TicketProducts/TicketProductForm.tsx",
        "routePaths": [
          "/ticket-product-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/Tickets/Transactions/index.tsx",
        "routePaths": [
          "/ticket-list"
        ]
      },
      {
        "pageFile": "src/pages/Tickets/TransactionsCanceled/index.tsx",
        "routePaths": [
          "/canceled-ticket-list"
        ]
      },
      {
        "pageFile": "src/pages/Users/Profile.tsx",
        "routePaths": [
          "/profile"
        ]
      },
      {
        "pageFile": "src/pages/Users/UserDetail/index.tsx",
        "routePaths": [
          "/user/:id"
        ]
      },
      {
        "pageFile": "src/pages/Users/UserList/index.tsx",
        "routePaths": [
          "/user-list"
        ]
      },
      {
        "pageFile": "src/pages/Vouchers/B2BVoucher/B2BVoucherStockForm.tsx",
        "routePaths": [
          "/b2b-voucher-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/Vouchers/SendVoucherCoupon/index.tsx",
        "routePaths": [
          "/voucher-send-coupon"
        ]
      },
      {
        "pageFile": "src/pages/Vouchers/UserVoucherGiftList/index.tsx",
        "routePaths": [
          "/user-voucher-gift-list"
        ]
      },
      {
        "pageFile": "src/pages/Vouchers/UserVoucherList/index.tsx",
        "routePaths": [
          "/user-voucher-list"
        ]
      },
      {
        "pageFile": "src/pages/Vouchers/VoucherList/VoucherForm.tsx",
        "routePaths": [
          "/voucher-form/:id"
        ]
      }
    ]
  },
  {
    "id": "table",
    "label": "Table",
    "sourceFiles": [
      "src/Components/ui/primitives.tsx",
      "src/Components/ui/shadcn/table.tsx"
    ],
    "usages": [
      {
        "pageFile": "src/pages/CampSite/Site/index.tsx",
        "routePaths": [
          "/site-form"
        ]
      },
      {
        "pageFile": "src/pages/Compliance/ComplianceArticleList.tsx",
        "routePaths": [
          "/compliance"
        ]
      },
      {
        "pageFile": "src/pages/Coupons/BenefitRule/index.tsx",
        "routePaths": [
          "/benefit-rule-list"
        ]
      },
      {
        "pageFile": "src/pages/Coupons/Coupon/index.tsx",
        "routePaths": [
          "/coupon-list"
        ]
      },
      {
        "pageFile": "src/pages/Coupons/UserCoupon/UserCouponList.tsx",
        "routePaths": [
          "/user-coupon-list"
        ]
      },
      {
        "pageFile": "src/pages/member/AuthSessionManagementPage.tsx",
        "routePaths": [
          "/member-auth-sessions"
        ]
      },
      {
        "pageFile": "src/pages/Messaging/index.ts",
        "routePaths": [
          "/messaging-history",
          "/messaging-send",
          "/messaging-senders",
          "/messaging-site-config",
          "/messaging-templates"
        ]
      },
      {
        "pageFile": "src/pages/Notification/NotificationCenter/index.tsx",
        "routePaths": [
          "/notification-center",
          "/notification-center/channels",
          "/notification-center/history",
          "/notification-center/hq",
          "/notification-center/send",
          "/notification-center/system",
          "/notification-center/templates"
        ]
      },
      {
        "pageFile": "src/pages/Notification/NotificationList/index.tsx",
        "routePaths": [
          "/notification-list"
        ]
      },
      {
        "pageFile": "src/pages/Orders/OrderErrorHandlingList.tsx",
        "routePaths": [
          "/order-error-handlings"
        ]
      },
      {
        "pageFile": "src/pages/Orders/UserOrderTotalList.tsx",
        "routePaths": [
          "/user-order-total"
        ]
      },
      {
        "pageFile": "src/pages/PreCoupons/PreCouponList/index.tsx",
        "routePaths": [
          "/user-precoupon-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/CanceledReservationList/index.tsx",
        "routePaths": [
          "/canceled-reservation-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/DailyReservationList/index.tsx",
        "routePaths": [
          "/daily-reservation-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/OptionProductList/index.tsx",
        "routePaths": [
          "/option-product-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationCalendar/index.tsx",
        "routePaths": [
          "/reservation-calendar/"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationGiftList/index.tsx",
        "routePaths": [
          "/reservation-gift-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationList/index.tsx",
        "routePaths": [
          "/reservation-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationList/ReservationAddItem.tsx",
        "routePaths": [
          "/reservation-add-item",
          "/reservation-add-item/:id"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationOptionList/index.tsx",
        "routePaths": [
          "/reservation-option-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationOptionList/ReservationOptionAddItem.tsx",
        "routePaths": [
          "/reservation-option-add-item",
          "/reservation-option-add-item/:id"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationProducts/index.tsx",
        "routePaths": [
          "/reservation-products"
        ]
      },
      {
        "pageFile": "src/pages/Shopping/ShoppingAdmin/index.tsx",
        "routePaths": [
          "/shopping-admin"
        ]
      },
      {
        "pageFile": "src/pages/Shopping/ShoppingProducts/index.tsx",
        "routePaths": [
          "/shopping-product-list"
        ]
      },
      {
        "pageFile": "src/pages/Shopping/ShoppingProducts/ShoppingProductForm.tsx",
        "routePaths": [
          "/shopping-product-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/Statistics/CoreMetrics/index.tsx",
        "routePaths": [
          "/core-metrics"
        ]
      },
      {
        "pageFile": "src/pages/Statistics/SalesStatistics/index.tsx",
        "routePaths": [
          "/sales-statistics"
        ]
      },
      {
        "pageFile": "src/pages/Statistics/StatisticsAdjustment/index.tsx",
        "routePaths": [
          "/statistics-adjustment"
        ]
      },
      {
        "pageFile": "src/pages/Supply/SupplyAdmin/index.tsx",
        "routePaths": [
          "/supply-admin"
        ]
      },
      {
        "pageFile": "src/pages/Supply/SupplyList/index.tsx",
        "routePaths": [
          "/supply-list"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/Menus/index.tsx",
        "routePaths": [
          "/table-order/menus"
        ]
      },
      {
        "pageFile": "src/pages/Tickets/TicketGiftList/index.tsx",
        "routePaths": [
          "/ticket-gift-list"
        ]
      },
      {
        "pageFile": "src/pages/Tickets/TicketProducts/index.tsx",
        "routePaths": [
          "/ticket-products"
        ]
      },
      {
        "pageFile": "src/pages/Tickets/Transactions/index.tsx",
        "routePaths": [
          "/ticket-list"
        ]
      },
      {
        "pageFile": "src/pages/Tickets/TransactionsCanceled/index.tsx",
        "routePaths": [
          "/canceled-ticket-list"
        ]
      },
      {
        "pageFile": "src/pages/Users/UserDetail/index.tsx",
        "routePaths": [
          "/user/:id"
        ]
      },
      {
        "pageFile": "src/pages/Users/UserList/index.tsx",
        "routePaths": [
          "/user-list"
        ]
      },
      {
        "pageFile": "src/pages/Vouchers/UserVoucherGiftList/index.tsx",
        "routePaths": [
          "/user-voucher-gift-list"
        ]
      },
      {
        "pageFile": "src/pages/Vouchers/UserVoucherList/index.tsx",
        "routePaths": [
          "/user-voucher-list"
        ]
      }
    ]
  },
  {
    "id": "datepicker",
    "label": "DatePicker",
    "sourceFiles": [
      "src/Components/Common/CommonDatePicker.tsx"
    ],
    "usages": [
      {
        "pageFile": "src/pages/CampSite/Site/index.tsx",
        "routePaths": [
          "/site-form"
        ]
      },
      {
        "pageFile": "src/pages/Coupons/B2BCoupon/B2BCouponStockForm.tsx",
        "routePaths": [
          "/b2b-coupon-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/Coupons/Coupon/CouponForm.tsx",
        "routePaths": [
          "/coupon-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/Coupons/CouponBook/CouponBookForm.tsx",
        "routePaths": [
          "/couponbook-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/DashboardCrm/index.tsx",
        "routePaths": [
          "/dashboard-crm"
        ]
      },
      {
        "pageFile": "src/pages/Messaging/index.ts",
        "routePaths": [
          "/messaging-history",
          "/messaging-send",
          "/messaging-senders",
          "/messaging-site-config",
          "/messaging-templates"
        ]
      },
      {
        "pageFile": "src/pages/Notice/index.ts",
        "routePaths": [
          "/announce-list",
          "/notice-form/:id",
          "/notice-list"
        ]
      },
      {
        "pageFile": "src/pages/Notification/PushAppNotification.tsx",
        "routePaths": [
          "/push-app-notification"
        ]
      },
      {
        "pageFile": "src/pages/Orders/UserOrderTotalList.tsx",
        "routePaths": [
          "/user-order-total"
        ]
      },
      {
        "pageFile": "src/pages/PreCoupons/B2BPreCoupon/B2BPreCouponStockForm.tsx",
        "routePaths": [
          "/b2b-precoupon-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/PreCoupons/PreCouponProducts/PreCouponForm.tsx",
        "routePaths": [
          "/precoupon-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/DailyReservationList/index.tsx",
        "routePaths": [
          "/daily-reservation-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationCalendar/index.tsx",
        "routePaths": [
          "/reservation-calendar/"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationList/index.tsx",
        "routePaths": [
          "/reservation-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationOptionList/index.tsx",
        "routePaths": [
          "/reservation-option-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationProducts/ReservationAddProduct.tsx",
        "routePaths": [
          "/reservation-add-product/:id"
        ]
      },
      {
        "pageFile": "src/pages/Shopping/ShoppingAdmin/index.tsx",
        "routePaths": [
          "/shopping-admin"
        ]
      },
      {
        "pageFile": "src/pages/Shopping/ShoppingProducts/ShoppingProductForm.tsx",
        "routePaths": [
          "/shopping-product-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/Statistics/CoreMetrics/index.tsx",
        "routePaths": [
          "/core-metrics"
        ]
      },
      {
        "pageFile": "src/pages/Statistics/SalesStatistics/index.tsx",
        "routePaths": [
          "/sales-statistics"
        ]
      },
      {
        "pageFile": "src/pages/Supply/SupplyList/index.tsx",
        "routePaths": [
          "/supply-list"
        ]
      },
      {
        "pageFile": "src/pages/Supply/SupplyProducts/SupplyProductForm.tsx",
        "routePaths": [
          "/supply-product-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/Tickets/TicketProducts/TicketProductForm.tsx",
        "routePaths": [
          "/ticket-product-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/Tickets/Transactions/index.tsx",
        "routePaths": [
          "/ticket-list"
        ]
      },
      {
        "pageFile": "src/pages/Tickets/TransactionsCanceled/index.tsx",
        "routePaths": [
          "/canceled-ticket-list"
        ]
      },
      {
        "pageFile": "src/pages/Users/UserDetail/index.tsx",
        "routePaths": [
          "/user/:id"
        ]
      },
      {
        "pageFile": "src/pages/Vouchers/B2BVoucher/B2BVoucherStockForm.tsx",
        "routePaths": [
          "/b2b-voucher-form/:id"
        ]
      },
      {
        "pageFile": "src/pages/Vouchers/VoucherList/VoucherForm.tsx",
        "routePaths": [
          "/voucher-form/:id"
        ]
      }
    ]
  },
  {
    "id": "paginated-table",
    "label": "Paginated Table",
    "sourceFiles": [
      "src/Components/Common/TableContainer.tsx",
      "src/Components/Common/ServerPaginatedTable.tsx"
    ],
    "usages": [
      {
        "pageFile": "src/pages/Compliance/ComplianceArticleList.tsx",
        "routePaths": [
          "/compliance"
        ]
      },
      {
        "pageFile": "src/pages/Coupons/UserCoupon/UserCouponList.tsx",
        "routePaths": [
          "/user-coupon-list"
        ]
      },
      {
        "pageFile": "src/pages/Messaging/index.ts",
        "routePaths": [
          "/messaging-history",
          "/messaging-send",
          "/messaging-senders",
          "/messaging-site-config",
          "/messaging-templates"
        ]
      },
      {
        "pageFile": "src/pages/Notification/NotificationList/index.tsx",
        "routePaths": [
          "/notification-list"
        ]
      },
      {
        "pageFile": "src/pages/Orders/OrderErrorHandlingList.tsx",
        "routePaths": [
          "/order-error-handlings"
        ]
      },
      {
        "pageFile": "src/pages/Orders/UserOrderTotalList.tsx",
        "routePaths": [
          "/user-order-total"
        ]
      },
      {
        "pageFile": "src/pages/PreCoupons/PreCouponList/index.tsx",
        "routePaths": [
          "/user-precoupon-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/CanceledReservationList/index.tsx",
        "routePaths": [
          "/canceled-reservation-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/DailyReservationList/index.tsx",
        "routePaths": [
          "/daily-reservation-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationCalendar/index.tsx",
        "routePaths": [
          "/reservation-calendar/"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationGiftList/index.tsx",
        "routePaths": [
          "/reservation-gift-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationList/index.tsx",
        "routePaths": [
          "/reservation-list"
        ]
      },
      {
        "pageFile": "src/pages/Reservations/ReservationOptionList/index.tsx",
        "routePaths": [
          "/reservation-option-list"
        ]
      },
      {
        "pageFile": "src/pages/Shopping/ShoppingAdmin/index.tsx",
        "routePaths": [
          "/shopping-admin"
        ]
      },
      {
        "pageFile": "src/pages/Supply/SupplyAdmin/index.tsx",
        "routePaths": [
          "/supply-admin"
        ]
      },
      {
        "pageFile": "src/pages/Supply/SupplyList/index.tsx",
        "routePaths": [
          "/supply-list"
        ]
      },
      {
        "pageFile": "src/pages/Tickets/TicketGiftList/index.tsx",
        "routePaths": [
          "/ticket-gift-list"
        ]
      },
      {
        "pageFile": "src/pages/Tickets/Transactions/index.tsx",
        "routePaths": [
          "/ticket-list"
        ]
      },
      {
        "pageFile": "src/pages/Tickets/TransactionsCanceled/index.tsx",
        "routePaths": [
          "/canceled-ticket-list"
        ]
      },
      {
        "pageFile": "src/pages/Users/UserDetail/index.tsx",
        "routePaths": [
          "/user/:id"
        ]
      },
      {
        "pageFile": "src/pages/Users/UserList/index.tsx",
        "routePaths": [
          "/user-list"
        ]
      },
      {
        "pageFile": "src/pages/Vouchers/UserVoucherGiftList/index.tsx",
        "routePaths": [
          "/user-voucher-gift-list"
        ]
      },
      {
        "pageFile": "src/pages/Vouchers/UserVoucherList/index.tsx",
        "routePaths": [
          "/user-voucher-list"
        ]
      }
    ],
    "variants": [
      {
        "id": "table-container",
        "label": "TableContainer",
        "sourceFiles": [
          "src/Components/Common/TableContainer.tsx"
        ],
        "usages": [
          {
            "pageFile": "src/pages/Supply/SupplyList/index.tsx",
            "routePaths": [
              "/supply-list"
            ]
          },
          {
            "pageFile": "src/pages/Tickets/Transactions/index.tsx",
            "routePaths": [
              "/ticket-list"
            ]
          },
          {
            "pageFile": "src/pages/Tickets/TransactionsCanceled/index.tsx",
            "routePaths": [
              "/canceled-ticket-list"
            ]
          },
          {
            "pageFile": "src/pages/Users/UserDetail/index.tsx",
            "routePaths": [
              "/user/:id"
            ]
          }
        ]
      },
      {
        "id": "server-paginated-table",
        "label": "ServerPaginatedTable",
        "sourceFiles": [
          "src/Components/Common/ServerPaginatedTable.tsx"
        ],
        "usages": [
          {
            "pageFile": "src/pages/Compliance/ComplianceArticleList.tsx",
            "routePaths": [
              "/compliance"
            ]
          },
          {
            "pageFile": "src/pages/Coupons/UserCoupon/UserCouponList.tsx",
            "routePaths": [
              "/user-coupon-list"
            ]
          },
          {
            "pageFile": "src/pages/Messaging/index.ts",
            "routePaths": [
              "/messaging-history",
              "/messaging-send",
              "/messaging-senders",
              "/messaging-site-config",
              "/messaging-templates"
            ]
          },
          {
            "pageFile": "src/pages/Notification/NotificationList/index.tsx",
            "routePaths": [
              "/notification-list"
            ]
          },
          {
            "pageFile": "src/pages/Orders/OrderErrorHandlingList.tsx",
            "routePaths": [
              "/order-error-handlings"
            ]
          },
          {
            "pageFile": "src/pages/Orders/UserOrderTotalList.tsx",
            "routePaths": [
              "/user-order-total"
            ]
          },
          {
            "pageFile": "src/pages/PreCoupons/PreCouponList/index.tsx",
            "routePaths": [
              "/user-precoupon-list"
            ]
          },
          {
            "pageFile": "src/pages/Reservations/CanceledReservationList/index.tsx",
            "routePaths": [
              "/canceled-reservation-list"
            ]
          },
          {
            "pageFile": "src/pages/Reservations/DailyReservationList/index.tsx",
            "routePaths": [
              "/daily-reservation-list"
            ]
          },
          {
            "pageFile": "src/pages/Reservations/ReservationCalendar/index.tsx",
            "routePaths": [
              "/reservation-calendar/"
            ]
          },
          {
            "pageFile": "src/pages/Reservations/ReservationGiftList/index.tsx",
            "routePaths": [
              "/reservation-gift-list"
            ]
          },
          {
            "pageFile": "src/pages/Reservations/ReservationList/index.tsx",
            "routePaths": [
              "/reservation-list"
            ]
          },
          {
            "pageFile": "src/pages/Reservations/ReservationOptionList/index.tsx",
            "routePaths": [
              "/reservation-option-list"
            ]
          },
          {
            "pageFile": "src/pages/Shopping/ShoppingAdmin/index.tsx",
            "routePaths": [
              "/shopping-admin"
            ]
          },
          {
            "pageFile": "src/pages/Supply/SupplyAdmin/index.tsx",
            "routePaths": [
              "/supply-admin"
            ]
          },
          {
            "pageFile": "src/pages/Supply/SupplyList/index.tsx",
            "routePaths": [
              "/supply-list"
            ]
          },
          {
            "pageFile": "src/pages/Tickets/TicketGiftList/index.tsx",
            "routePaths": [
              "/ticket-gift-list"
            ]
          },
          {
            "pageFile": "src/pages/Tickets/Transactions/index.tsx",
            "routePaths": [
              "/ticket-list"
            ]
          },
          {
            "pageFile": "src/pages/Tickets/TransactionsCanceled/index.tsx",
            "routePaths": [
              "/canceled-ticket-list"
            ]
          },
          {
            "pageFile": "src/pages/Users/UserDetail/index.tsx",
            "routePaths": [
              "/user/:id"
            ]
          },
          {
            "pageFile": "src/pages/Users/UserList/index.tsx",
            "routePaths": [
              "/user-list"
            ]
          },
          {
            "pageFile": "src/pages/Vouchers/UserVoucherGiftList/index.tsx",
            "routePaths": [
              "/user-voucher-gift-list"
            ]
          },
          {
            "pageFile": "src/pages/Vouchers/UserVoucherList/index.tsx",
            "routePaths": [
              "/user-voucher-list"
            ]
          }
        ]
      }
    ]
  }
];

export default sharedUiMetadata;
